import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";

import { createDemoBooking } from "../services/demoBookingService";

const BookDemo = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    companyName: "",
    preferredDate: "",
    preferredTime: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] =
    useState("");
  const [errorMessage, setErrorMessage] =
    useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      const response = await createDemoBooking(
        formData
      );

      setSuccessMessage(
        response.message ||
          "Your demo has been booked successfully."
      );

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        companyName: "",
        preferredDate: "",
        preferredTime: "",
        message: "",
      });
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message ||
          "Failed to book demo. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const today = new Date()
    .toISOString()
    .split("T")[0];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f5f7fb",
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 3,
            border: "1px solid #e5e7eb",
          }}
        >
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{
              color: "#1e3a8a",
              mb: 1,
            }}
          >
            Book a Demo
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              mb: 4,
            }}
          >
            Schedule a personalized ExiHire demo
            with our team.
          </Typography>

          {successMessage && (
            <Alert
              severity="success"
              sx={{ mb: 3 }}
            >
              {successMessage}
            </Alert>
          )}

          {errorMessage && (
            <Alert
              severity="error"
              sx={{ mb: 3 }}
            >
              {errorMessage}
            </Alert>
          )}

          <Box
            component="form"
            onSubmit={handleSubmit}
          >
            <TextField
              fullWidth
              required
              label="Full Name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              required
              type="email"
              label="Work Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              label="Phone Number (Optional)"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              label="Company Name"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              required
              type="date"
              label="Preferred Date"
              name="preferredDate"
              value={formData.preferredDate}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: today,
              }}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              required
              type="time"
              label="Preferred Time"
              name="preferredTime"
              value={formData.preferredTime}
              onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ mb: 2.5 }}
            />

            <TextField
              fullWidth
              multiline
              rows={4}
              label="Message (Optional)"
              name="message"
              value={formData.message}
              onChange={handleChange}
              sx={{ mb: 3 }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              disabled={loading}
              sx={{
                py: 1.5,
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 600,
                backgroundColor: "#1e40af",
              }}
            >
              {loading ? (
                <CircularProgress
                  size={24}
                  color="inherit"
                />
              ) : (
                "Book Demo"
              )}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default BookDemo;